import React from "react";
import styled from "styled-components";
import { Loading } from "../../Loading";
import ReactHtmlParser from 'react-html-parser';
import { LazyImage } from "../../Scomp/LazyImage";

const CartStyle = styled.div`

    --n-primary-2: #0E3D5C;
    --n-grey-2: #E5E5E5;
    --n-grey-3: #CBCBCB;
    --n-grey-7: #979797;
    --n-grey-9: #5E5E5E;

    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: start;
    background-color: var(--body-2);
    box-shadow: 0px 4px 30px -4px #0000001F;
    /* box-shadow: var(--shadow-22); */
    border-radius: 8px;
    flex-grow: 1;
    text-decoration: none;
    color: inherit;
    transition: all 0.2s ease-in-out;
    :hover {
        box-shadow: 0px 4px 12px -4px #0000001F;
    }
    .good-image{
        display: block;
        position: relative;
        width: calc(100%);
        padding: 0 0 0.5rem;
        min-height: 10rem;
        border-radius: 8px;
        object-fit: cover;
        aspect-ratio: 2;
    }
    .good-detail {
        display: flex;
        gap: 0.5rem;
        font-size: 0.7rem;
        font-weight: 400;
        color: #979797;
        padding: 0.5rem 1rem;
        justify-content: space-between;
        .data {
            display: flex;
            gap: 0.2rem;
            align-items: center;
            .text {
                padding: 0.15rem 0 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .line {
            width: 1px;
            background-color: #979797;
        }
    }
    .empry-img{
        background: #E5E5E5;
        display: inline-block;
        height: 5rem;
        -webkit-mask:linear-gradient(-60deg,#000 30%,#0005,#000 70%) right/300% 100%;
        background-repeat: no-repeat;
        animation: shimmer 1.5s infinite;
        font-size: 50px;
    }
    
    @keyframes shimmer {
    100% {-webkit-mask-position:left}
    }   

    .good-desc{
        padding: 0.5rem 1rem ;
        text-align: right;
        font-size: 1rem;
        min-height: 3rem;
        flex-grow: 1;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        .title{
            font-size:1rem ;
            font-weight: 700;
        }
        .desc{
            flex-wrap: wrap;
            text-overflow: ellipsis;
            text-align: right;
            margin: 0.5rem 0;
            font-weight: 300;
            font-size: 0.8rem;
            p {
                padding: 0;
                margin: 0;
            }
        }
    }
   
    .good-more{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0rem 1rem 1rem;
        width: calc(100% - 2rem);
        /* border-top:  1px solid var(--n-grey-2); ; */
        .date{
            font-weight: 700;
            font-size: 0.8rem;
        }
        .view{
            color: #1677D9;
            font-weight: 500;
            font-size: 0.75rem;
            text-decoration: none;
            cursor: pointer;
        }
    }
`



const BlogPost =(props)=>{
    const alldata = props.data
    // let tit = alldata.title.replaceAll('&#8211;', '-');
    let tit = ReactHtmlParser(alldata.title);
    let desc = ReactHtmlParser(alldata.short_desc);
    // let desc = alldata.short_desc.replaceAll('&#8230;', '');
    // desc = desc.replaceAll('<p>', '');
    // desc = desc.replaceAll('</p>', '');
    let newDate = alldata.date.split("T")[0].split("-");
    let date = new Date(alldata.date.split("T")[0])
    let nowDate = new Date()
    let def = Math.abs(Math.floor((date - nowDate)/(1000*60*60*24)))
    let text = def + " روز پیش"
    if(def > 7){
        text = Math.floor(def/7) + " هفته پیش"
    }
    if(def > 30){
        text = Math.floor(def/30) + " ماه پیش"
    }
    // date.setFullYear(newDate[0])
    // date.setMonth(newDate[1])
    // date.setDate(newDate[2])
    let blogimage = alldata.image_link;
    if(alldata.image_link){
        blogimage = alldata.image_link.replace(".jpeg", "-600x350.jpeg")
    }
    if( alldata ){
        return (
            <CartStyle>
                <LazyImage className="good-image" src={blogimage} alt={tit}/>
                <div className="good-detail">
                    <span className="data">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M11.4454 2.48501C11.4148 2.25799 11.2217 2.08301 10.9881 2.08301C10.7332 2.08301 10.5266 2.29125 10.5266 2.54812V3.06228H6.47845V2.54812L6.47423 2.48501C6.44367 2.25799 6.25057 2.08301 6.01691 2.08301C5.76201 2.08301 5.55537 2.29125 5.55537 2.54812V3.07385C3.66424 3.20423 2.5 4.42966 2.5 6.40679V12.019C2.5 14.1411 3.80556 15.4163 5.8975 15.4163H11.1024C13.1969 15.4163 14.5 14.1624 14.5 12.0659V6.40679C14.506 4.42873 13.3452 3.20359 11.4496 3.07375V2.54812L11.4454 2.48501ZM10.5266 3.99255V4.58892L10.5308 4.65203C10.5613 4.87906 10.7544 5.05403 10.9881 5.05403C11.243 5.05403 11.4496 4.84579 11.4496 4.58892V4.00632C12.8285 4.12115 13.5807 4.95157 13.5763 6.4054V6.67479H3.42245V6.40683C3.42245 4.9537 4.17899 4.12149 5.55537 4.00636V4.58892L5.55959 4.65203C5.59015 4.87906 5.78325 5.05403 6.01691 5.05403C6.27181 5.05403 6.47845 4.84579 6.47845 4.58892V3.99255H10.5266ZM3.42245 7.60502V12.019C3.42245 13.6207 4.30839 14.4861 5.89688 14.4861H11.1018C12.6958 14.4861 13.5763 13.6388 13.5763 12.0659L13.5763 7.60502H3.42245ZM11.7011 9.56192C11.7011 9.30505 11.4945 9.09681 11.2396 9.09681L11.1712 9.10105C10.946 9.13185 10.7723 9.32645 10.7723 9.56192C10.7723 9.8188 10.979 10.027 11.2396 10.027L11.3022 10.0228C11.5275 9.99199 11.7011 9.79739 11.7011 9.56192ZM8.50821 9.09681C8.76312 9.09681 8.96976 9.30505 8.96976 9.56192C8.96976 9.79739 8.79612 9.99199 8.57084 10.0228L8.50821 10.027C8.24761 10.027 8.04097 9.8188 8.04097 9.56192C8.04097 9.32645 8.21461 9.13185 8.43989 9.10105L8.50821 9.09681ZM6.23297 9.56192C6.23297 9.30505 6.02634 9.09681 5.77144 9.09681L5.70311 9.10105C5.47783 9.13185 5.3042 9.32645 5.3042 9.56192C5.3042 9.8188 5.51084 10.027 5.76574 10.027L5.83406 10.0228C6.05934 9.99199 6.23297 9.79739 6.23297 9.56192ZM11.2396 11.507C11.4945 11.507 11.7011 11.7152 11.7011 11.9721C11.7011 12.2076 11.5275 12.4022 11.3022 12.433L11.2396 12.4372C10.979 12.4372 10.7723 12.229 10.7723 11.9721C10.7723 11.7366 10.946 11.542 11.1712 11.5112L11.2396 11.507ZM8.96976 11.9721C8.96976 11.7152 8.76312 11.507 8.50821 11.507L8.43989 11.5112C8.21461 11.542 8.04097 11.7366 8.04097 11.9721C8.04097 12.229 8.24761 12.4372 8.50821 12.4372L8.57084 12.433C8.79612 12.4022 8.96976 12.2076 8.96976 11.9721ZM5.77144 11.507C6.02634 11.507 6.23297 11.7152 6.23297 11.9721C6.23297 12.2076 6.05934 12.4022 5.83406 12.433L5.76574 12.4372C5.51084 12.4372 5.3042 12.229 5.3042 11.9721C5.3042 11.7366 5.47783 11.542 5.70311 11.5112L5.77144 11.507Z" fill="#979797"/>
                        </svg>
                        <div className="text">
                            {text}
                        </div>
                    </span>
                    {/* <div className="line"></div> */}
                    {/* <span className="data"> */}
                    {/* </span> */}
                    {/* <div className="line"></div> */}
                    <span className="data">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.49967 1.58398C4.81753 1.58398 1.83301 4.56851 1.83301 8.25065C1.83301 11.9328 4.81753 14.9173 8.49967 14.9173C12.1818 14.9173 15.1663 11.9328 15.1663 8.25065C15.1663 4.56851 12.1818 1.58398 8.49967 1.58398ZM8.49967 2.58398C11.6295 2.58398 14.1663 5.12079 14.1663 8.25065C14.1663 11.3805 11.6295 13.9173 8.49967 13.9173C5.36982 13.9173 2.83301 11.3805 2.83301 8.25065C2.83301 5.12079 5.36982 2.58398 8.49967 2.58398ZM8.7692 5.41376C8.7361 5.16971 8.5269 4.98161 8.27377 4.98161C7.99763 4.98161 7.77377 5.20546 7.77377 5.48161V8.71294L7.77934 8.78743C7.80143 8.93414 7.888 9.06501 8.01761 9.14234L10.5309 10.6417L10.5915 10.6725C10.8181 10.7691 11.0868 10.6858 11.2165 10.4684L11.2473 10.4078C11.3439 10.1813 11.2606 9.91256 11.0433 9.78287L8.7735 8.42834L8.77377 5.48161L8.7692 5.41376Z" fill="#979797"/>
                        </svg>
                        <div className="text">
                            {alldata.read_time}
                        </div>
                    </span>
                </div>
                <div className="good-desc">
                    <span className="title">{tit}</span>
                    <span className="desc">
                    {desc.slice(0, 150)}
                    </span>
                </div>
                <div className="good-more">
                    {/* <span className="date">{alldata.read_time}</span> */}
                    <a href={alldata.link} className="view" >مشاهده بیشتر</a>
                </div>
            </CartStyle>
        )
    }
    return <CartStyle> <Loading/> </CartStyle> 

}
export default BlogPost;